import { Component, OnInit, ViewChildren, QueryList, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { APITemplateService } from '../../_services/template/API-template';
import { Constants } from '../../../../_utils/Constants';
import { APIHeaderService } from '../../_services/header/API-header';

const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);


@Component({
  selector: 'app-bulk-template-verification-summary',
  templateUrl: './bulk-template-verification-summary.component.html',
  styleUrls: ['./bulk-template-verification-summary.component.css'],
})
export class BulkTemplateVerificationSummaryComponent implements OnInit {

  filterData: any;
  form1: any = {};
  maxDate: Date = new Date();
  peid: any;
  noRecord: any;
  onSelectdropdown: boolean = true;
  dataSource: MatTableDataSource<any>;
  batchId: any;


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;

  dataSubject = new BehaviorSubject<any[]>([]);
  mindate = new Date(now.getFullYear(), 0, 1);
  maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  displayedColumns: string[] = [
    'BatchId',
    'createdAt',
    'Input_Count',
    //'Status',
    'Success_Count',
    'Failure_Count',
    'File_Name'];
  //'Exported_File'

  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private tem: APITemplateService,
    private db: $DBManagerService,
    private hs: APIHeaderService,

  ) { }

  ngOnInit() {

    this.peid = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    this.gettmpVerificationSummaryReport()
    this.maxDate.setDate(new Date().getDate());
    //this.form1.controls['Entity_ID'].setValue(this.peid);


  }

  gettmpVerificationSummaryReport() {

    let data = {
      "BatchId": "",
      "Start_Date": "",
      "End_Date": "",
      "peid": this.peid
    }

    this.tem.tmpVerificationSummaryReport(data).subscribe(result => {
      console.log("*********RESULT****", result)
      this.filterData = result;
      this.onChangeDataSource(this.filterData);
    })

  }

  onChangeDataSource(value) {
    //console.log("values" + value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.tSort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  onSubmitFilter(filterForm, form) {
    if (!form.valid) {
      return true;
    }


    let fdate = "", ldate = "";

    if (filterForm.startDate) {
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }

    if (filterForm.endDate) {
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    }
    if (filterForm.startDate && !filterForm.endDate) {
      ldate = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

    }

    if (!filterForm.startDate && filterForm.endDate) {
      this.$modal.errorModal({
        title: 'Bulk Template Verificaton Summary',
        msg: 'Please provide from date'
      });
      return
    }

    if ((filterForm.startDate == null || filterForm.startDate == undefined) && (filterForm.BatchId == null || filterForm.BatchId == undefined || filterForm.BatchId == "")) {
      this.$modal.errorModal({
        title: 'Bulk Template Verificaton Summary',
        msg: 'Please provide atleast one search criteria'
      });
      return
    }
    console.log("___________________", fdate, ldate)
    let BatchID
    if(filterForm.BatchId == null || filterForm.BatchId == undefined|| filterForm.BatchId == ""){
      BatchID = ""
    }
    else{
       BatchID = filterForm.BatchId;
    }
    let data = {
      "BatchId": BatchID,
      "Start_Date": fdate,
      "End_Date": ldate,
      "peid": this.peid
    }
    //let peID = this.ngForm.get("Entity_ID").value;
    this.tem.tmpVerificationSummaryReport(data)
      .subscribe(r => {
        this.filterData = r;

        this.onChangeDataSource(this.filterData);
        console.log("12345 :", this.filterData);
      })

  }

  reset() {
    this.gettmpVerificationSummaryReport()
    console.log("first reset function");
  }

  downloadcsvfile(bid) {
    let bid1 = bid
    var data = {
      "BatchID": bid1,
      "peid": this.peid
    }
    //let peID = this.form1.get("Entity_ID").value;
    // const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    console.log("************", data);
    this.tem.updateTmpVerificationSummary(data).subscribe(r => {

      console.log("*************R******", r)
      //  var fileName = currentdat + 'ContentBulkApprovalSummary.csv';
      var blob = new Blob([r], { type: 'text/xlsx' })
      var fileName = bid1 + '-Bulk Template Verificaton Summary.xlsx';
      // saveAs(blob, fileName); 
      console.log("*************fileName******", fileName)
      importedSaveAs(blob, fileName)
      this.$modal.successModal({
        title: 'Bulk Template Verificaton Summary',
        msg: 'File has been downloaded Successfully'
      });

    });
  }

}